import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const getAllActivities = createRoutine('Activities/getAll')
export const createGetAllActivitiesPromise = promisifyRoutine(getAllActivities)
